module.exports = __webpack_public_path__ + "img/a09b6c4.jpg";